import {useSelector,useDispatch} from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web'
import {FormattedMessage } from 'react-intl';
import { Card,Space ,Typography,Avatar,Divider,Button} from 'antd';


import {cleanUpReport} from '../../actions/reportDetailsAction';
import {cleanResourcesList} from '../../actions/resourcesAction';
//import {clearStorageData} from '../../utils/storage';
import {getFirstLetter} from '../../utils/stringFunctions';
import { RootState } from '../../store/store';

const { Text } = Typography;

const Profile=()=>{
  const dispatch=useDispatch();
  let history = useHistory();
  const {keycloak}=useKeycloak();
  const userState = useSelector((state:RootState) => state.user);

  const logoutHandler=()=> {
    history.push("/");
    dispatch(cleanUpReport());
    dispatch(cleanResourcesList());
    keycloak.logout();
    //clearStorageData();
  }

  return (<Card style={{textAlign:'center', margin:0, padding:0, border:0}}>
    <Space size={0} direction="vertical">
      <Avatar size="large">{`${getFirstLetter(userState.firstName)} ${getFirstLetter(userState.lastName)}`}</Avatar>
      <Text strong style={{padding:0, margin:0}}>{`${userState.firstName} ${userState.lastName}`}</Text>
      <Text style={{padding:0, margin:0}}>{userState.email}</Text>
    </Space>
    <Divider style={{justifyContent:'center', alignContent:'center', textAlign:'center'}}/>
      <Button size={'small'} style={{textAlign:'center', justifyContent:'center', alignContent:'center', fontSize:'small'}} onClick={logoutHandler}>
        <FormattedMessage
            id = "profile.button.logout"
            defaultMessage="Cerrar Sesión"
          />
        </Button>
  </Card>)
}
export default Profile;